import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import Input from '@src/components/inputs/Input'
import Textarea from '@src/components/inputs/Textarea'
import Select from '@src/components/inputs/Select'
import { css } from '@emotion/react'
import SectionBlock from '@src/components/product/form/ProductForm/SectionBlock'

const PackageForm = () => {
	const { getFieldProps, getCourierOptionsProps } = useMyProductFormContext()
	return (
		<SectionBlock title="택배 정보">
			<Select {...getCourierOptionsProps()} wrapperStyle={selectWrapperStyle} />
			<Input
				label="배송소요 시일"
				type="number"
				min="0"
				{...getFieldProps('shipping.shippingDay')}
				wrapperStyle={inputWrapperStyle}
				css={inputStyle}
			/>
			<Textarea
				label="배송비용 안내 문구"
				{...getFieldProps('shipping.shippingMsg')}
				wrapperStyle={inputWrapperStyle}
				css={textareaStyle}
				rows={3}
			/>
			<Input
				label="배송비(무료배송일 경우 0입력)"
				{...getFieldProps('shipping.price')}
				type="number"
				min="0"
				wrapperStyle={inputWrapperStyle}
				labelStyle={css`
					width: 100%;
				`}
				css={inputStyle}
			/>
			<Input
				{...getFieldProps('shipping.otherPrice')}
				label="도서산간 추가 배송비(제주 외)"
				type="number"
				min="0"
				wrapperStyle={inputWrapperStyle}
				labelStyle={css`
					width: 100%;
				`}
				css={inputStyle}
			/>
			<Input
				{...getFieldProps('shipping.jejuPrice')}
				label="도서산간 추가 배송비(제주)"
				type="number"
				min="0"
				wrapperStyle={inputWrapperStyle}
				labelStyle={css`
					width: 100%;
				`}
				css={inputStyle}
			/>
			<Input
				{...getFieldProps('shipping.refundPrice')}
				label="단순 변심시 반품 비용(일괄 적용)"
				type="number"
				min="0"
				wrapperStyle={inputWrapperStyle}
				labelStyle={css`
					white-space: nowrap;
				`}
				css={inputStyle}
			/>
			<Textarea
				{...getFieldProps('shipping.refundMsg')}
				label="반품비용 안내 문구"
				// rows={3}
				wrapperStyle={inputWrapperStyle}
				css={textareaStyle}
			/>
		</SectionBlock>
	)
}

const selectWrapperStyle = css`
	width: 20rem;
`

const inputWrapperStyle = css`
	margin-bottom: 1rem;
	flex-flow: column;
	width: 100%;
`
const inputStyle = css`
	box-sizing: border-box;
	width: 20rem;
`

const textareaStyle = css`
	width: 35rem;
	resize: vertical;
`

export default PackageForm
